import { render, staticRenderFns } from "./LivestreamTabs.vue?vue&type=template&id=7b65061e&scoped=true&"
import script from "./LivestreamTabs.vue?vue&type=script&lang=js&"
export * from "./LivestreamTabs.vue?vue&type=script&lang=js&"
import style0 from "./LivestreamTabs.vue?vue&type=style&index=0&id=7b65061e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b65061e",
  null
  
)

export default component.exports